import * as React from "react"
import * as Yup from "yup"
import Form, { FormElement } from "@modules/form/components/Form"
import { MdArrowForward } from "react-icons/md"
import {
  Button,
  InputConnectedField,
  StyledModalActions,
  Text,
} from "gatsby-interface"
import {
  gcloudStorageIntegrationConfig as text,
  ui as uiText,
} from "@modules/locales/default.js"
import { useConnectGcsToSiteMutation } from "@modules/cdn/gcloudStorage/queries.generated"
import { CdnIntegrationSharedProps } from "@modules/cdn/shared/types"

type FormValues = {
  projectId: string
  keyData: string
  bucket: string
  fileKeyPrefix: string
}

const validationSchema = Yup.object().shape<FormValues>({
  projectId: Yup.string().required(uiText.messages.validationIsRequired),
  keyData: Yup.string().required(uiText.messages.validationIsRequired),
  bucket: Yup.string().required(uiText.messages.validationIsRequired),
  fileKeyPrefix: Yup.string(),
})

export type GCloudStorageIntegrationFormProps = CdnIntegrationSharedProps

export function GCloudStorageIntegrationForm({
  siteId,
  integration,
  onSetCDNConfig,
  onSubmitFailed,
  onCancel,
}: GCloudStorageIntegrationFormProps) {
  const [mutate] = useConnectGcsToSiteMutation()

  return (
    <Form<FormValues>
      validationSchema={validationSchema}
      initialValues={{
        projectId: integration?.config?.projectId ?? ``,
        keyData: integration?.config?.keyData ?? ``,
        bucket: integration?.config?.bucket ?? ``,
        fileKeyPrefix: integration?.config?.fileKeyPrefix ?? ``,
      }}
      onSubmit={values => {
        mutate({
          variables: {
            siteId,
            config: values,
          },
        })
          .then(({ data }) => {
            return onSetCDNConfig({
              success: data?.connectGCSToSite?.success ?? false,
              errorType: data?.connectGCSToSite?.errorType,
            })
          })
          .catch(onSubmitFailed)
      }}
    >
      {({ isSubmitting }) => (
        <FormElement applySpacing noValidate>
          <Text css={{ margin: 0 }}>{text.messages.introText}:</Text>
          <InputConnectedField
            label={text.labels.gcsProjectId}
            name="projectId"
            required
          />
          <InputConnectedField
            label={text.labels.gcsKeyData}
            name="keyData"
            hint={text.messages.gcsKeyDataDescription}
            required
          />
          <InputConnectedField
            label={text.labels.gcsBucket}
            name="bucket"
            required
          />
          <InputConnectedField
            label={text.labels.gcsFileKeyPrefix}
            name="fileKeyPrefix"
          />

          <StyledModalActions>
            <Button variant="SECONDARY" type="reset" onClick={onCancel}>
              {uiText.actions.cancel}
            </Button>
            <Button
              type="submit"
              loading={isSubmitting}
              rightIcon={<MdArrowForward />}
            >
              {uiText.actions.save}
            </Button>
          </StyledModalActions>
        </FormElement>
      )}
    </Form>
  )
}
